import { TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import { Controller, ControllerProps, FieldPath, FieldValues } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import type { NumericFormatProps } from 'react-number-format';

type MoneyTextFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
> = NumericFormatProps<TextFieldProps> & Pick<ControllerProps<TFieldValues, TName>, 'name' | 'control'>;

export const MoneyTextField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  control,
  ...props
}: MoneyTextFieldProps<TFieldValues, TName>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, name, value, ...fields }, fieldState: { error } }) => {
        return (
          <NumericFormat
            {...props}
            decimalScale={2}
            inputProps={{ maxLength: 19 }}
            thousandSeparator=" "
            name={name}
            error={error != null}
            helperText={error?.message}
            value={value ?? ''}
            onChange={onChange}
            onBlur={onBlur}
            customInput={TextField}
          />
        );
      }}
    />
  );
};
